@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.wrapper {
  margin-top: variables.$std-margin-5xl;
}

.buttonDistrictInfo {
  display: flex;
  align-items: center;
}

.districtInfo {
  margin: 0 variables.$std-margin-md;
}

.setUploadTypeHeader {
  display: flex;
  align-items: center;
  margin-bottom: variables.$std-margin-sm;
}

.uploadTypeSelector {
  width: 10%;
  margin-left: variables.$std-margin-sm;
}

.uploadAssessmenmtTypeSelector {
  width: 20%;
  margin-left: variables.$std-margin-sm;
}

.scoreColumnInput {
  width: 30%;
  margin-left: variables.$std-margin-sm;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
